import { createSlice } from '@reduxjs/toolkit'

export const onSaveClassroomReducer = (state, { payload }) => {
  const { classroom } = payload

  const newState = {
    ...state,
    classroom
  }

  return newState
}

export const onUpdateActivitiesReducer = (state, { payload }) => {
  const { activities, classroomId, totalCount } = payload
  const newState = {
    ...state,
    classroomActivities: {
      classroomId,
      activities,
      totalCount
    }
  }

  return newState
}

export const setActivityToLoadReducer = (state, { payload }) => {
  const { activityId } = payload

  const newState = {
    ...state,
    activityId
  }
  return newState
}

export const updateAssignments = (state, { payload }) => {
  const assignmentsShouldUpdate = payload

  const newState = {
    ...state,
    assignmentsShouldUpdate
  }
  return newState
}

export const setActiveItemReducer = (state, { payload }) => {
  const { activeItem } = payload

  const newState = {
    ...state,
    activeItem
  }
  return newState
}

export const setClasscodeReducer = (state, { payload }) => {
  const { classCode } = payload

  const newState = {
    ...state,
    classCode
  }

  return newState
}

export const setClassroomCodeReducer = (state, { payload }) => {
  const code = payload

  return {
    ...state,
    classroom: {
      ...state.classroom,
      code
    }
  }
}

export const setDropDownTagReducer = (state, { payload }) => {
  const tagData = payload

  return {
    ...state,
    tags: { ...state.tags, ...tagData }
  }
}

export const updateSharesReducer = (state, { payload }) => {
  const shares = payload

  return {
    ...state,
    classroom: {
      ...state.classroom,
      shares
    }
  }
}

export const setClassroomListReducer = (state, { payload }) => {
  const classroomList = payload

  return {
    ...state,
    classroomList
  }
}

export const addStudentToClassroom = (state, { payload }) => {
  const student = payload

  return {
    ...state,
    classroom: { ...state.classroom, students: [...state.classroom.students, student] }
  }
}

export const onCheckGoogleStatusReducer = (state, { payload }) => {
  const googleProgressNeedsUpdate = payload
  return {
    ...state,
    googleProgressNeedsUpdate
  }
}

export const setClearClassroomReducer = (state) => {
  const newState = {
    ...state,
    classroom: {
      id: null,
      name: null,
      code: null,
      activities: [],
      courses: [],
      classType: '',
      archivedAt: null,
      shares: []
    },
    classroomActivities: {
      classroomId: null,
      activities: []
    },
    classCode: '',
    tags: {},
    activeItem: 0,
    activityId: -1,
    assignmentsShouldUpdate: 0,
    googleProgressNeedsUpdate: 0
  }

  return newState
}

const dashboardSlice = createSlice({
  name: 'classroom',
  initialState: {
    classroomList: [],
    activeItem: 0,
    classroom: {
      id: null,
      name: null,
      code: null,
      activities: [],
      courses: [],
      classType: '',
      archivedAt: null,
      shares: [],
      students: []
    },
    classroomActivities: {
      classroomId: null,
      activities: []
    },
    classCode: '',
    tags: {},
    activityId: -1,
    assignmentsShouldUpdate: 0,
    googleProgressNeedsUpdate: 0
  },
  reducers: {
    onSaveClassroom: onSaveClassroomReducer,
    setClasscode: setClasscodeReducer,
    setClassroomCode: setClassroomCodeReducer,
    updateShares: updateSharesReducer,
    onDropDownTag: setDropDownTagReducer,
    clearClassroom: setClearClassroomReducer,
    updateActivites: onUpdateActivitiesReducer,
    setActivityToLoad: setActivityToLoadReducer,
    setClassroomList: setClassroomListReducer,
    onSetActiveItem: setActiveItemReducer,
    onUpdateAssignments: updateAssignments,
    onAddStudent: addStudentToClassroom,
    onCheckGoogleStatus: onCheckGoogleStatusReducer
  }
})

const { actions, reducer } = dashboardSlice

export const {
  onSaveClassroom,
  setClasscode,
  setClassroomCode,
  updateShares,
  onDropDownTag,
  clearClassroom,
  updateActivites,
  setActivityToLoad,
  setClassroomList,
  onSetActiveItem,
  onUpdateAssignments,
  onAddStudent,
  onCheckGoogleStatus
} = actions

export default reducer
